import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { PRODUCT_SELECTOR_FRAGMENT } from 'graphql/fragments/product-selector';
import { Query as RootQuery } from 'graphql/models/generated';

export const SELECTOR_POSITION_QUERY = gql`
  query selectorLine(
    $documentVersion: DocumentVersionInput!,
    $lineId: String!,
    $withConfiguration: Boolean!,
    $datamodelVersionId: ID!,
    $filtersId: ID!,
    $frameImageId: ID!,
    $vtzFileId: ID!,
    $elementFilterId: ID!,
    $typeFilterId: ID!
  ) {
    quotes {
      quote(documentVersion: $documentVersion) {
        line(id: $lineId) {
          ...ProductSelectorFragment
        }
      }
    }
  }
  ${PRODUCT_SELECTOR_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class SelectorPositionQuery extends Query<RootQuery> {
  document = SELECTOR_POSITION_QUERY;
}
